import React from "react";

const Toast = ({ message, type }) => {
  return (
    <div
      className="toastlg-message"
      style={{
        backgroundColor: type === "success" ? "#4CAF50" : "#F44336",
      }}
    >
      <div className="toastlg-content">{message}</div>
    </div>
  );
};

export default Toast;
